export var ENTITIES_PER_PAGE = 100;
export var MAX_TABS = 5;
export var ALERT_DURATION = 2000;
export var TABS_PLACEHOLDER = { name: '', domain: '' };
